import React, {Component} from "react"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import ImageEditor from "@irati/ui/src/ImageEditor"
import {BRAND_LOGO_DIMENSIONS} from "@irati/brand/constants/brand"
import {H1, Body} from "@irati/ui/src/Typography"

import BackLink from "./BackLink"

const IMAGE_EDITOR_VERTICAL_PADDING = 20

interface Props extends InjectIntl {
  onComplete: () => void,
  backToUploadLogo: () => void,
  imageSource: string
}

interface State {
  imageScale: number
}

class ScaleLogoStep extends Component<Props, State> {
  state = {
    imageScale: 1
  }

  onUpdate = (imageScale: number) => {
    this.setState({imageScale})
  }

  render() {
    const {formatMessage} = this.props

    return (
      <>
        <BackLink onClick={this.props.backToUploadLogo} text="admin.components.brandSettings.button.uploadLogo" />
        <>
          <H1 marginBottom={4}>
            <FormattedMessage id="admin.components.scaleLogoStep.title" />
          </H1>
          <Body>
            <FormattedMessage id="admin.components.scaleLogoStep.subTitle" values={{br: <br />}} />
          </Body>
          <ImageEditor
            image={this.props.imageSource}
            width={BRAND_LOGO_DIMENSIONS.width * 2}
            height={BRAND_LOGO_DIMENSIONS.height * 2}
            border={[0, IMAGE_EDITOR_VERTICAL_PADDING]}
            color={[0, 0, 0, 0.1]}
            scale={this.state.imageScale}
            onUpdate={this.onUpdate}
            buttonText={formatMessage({id: "admin.components.scaleLogoStep.imageEditor.buttonText"})}
            onComplete={this.props.onComplete}
            largeBtn={false}
            centerSlider={false}
            style={{
              width: BRAND_LOGO_DIMENSIONS.width,
              height: BRAND_LOGO_DIMENSIONS.height + IMAGE_EDITOR_VERTICAL_PADDING,
              marginTop: 24
            }} />
        </>
      </>
    )
  }
}

export default injectIntl(ScaleLogoStep)
